import { Location } from "@angular/common";
import { inject, Injectable } from "@angular/core";

import { LOCALE, StorageService } from "@hermes/core-app-core";

export const SESSION_STORAGE_GRID_URL_KEY = "gridUrl";

/**
 * Manages a grid URL for back-button.
 */
@Injectable({
    providedIn: "root",
})
export class BackToGridService {
    private location = inject(Location);
    private storageService = inject(StorageService);
    private locale = inject(LOCALE);

    /**
     * Store URL of current grid in SessionStorage
     * @param url string URL of current grid
     */
    public storeGridUrl(url: string): void {
        this.storageService.setSessionStorageItem(
            SESSION_STORAGE_GRID_URL_KEY,
            // Might not be internal redirect if SPA routing is disable on back to grid button
            this.location.prepareExternalUrl(url),
        );
    }

    /**
     * At each grid loading, we can remove the stored grid URL.
     * At next product click, the new grid location will be saved.
     */
    public cleanGridUrl(): void {
        this.storageService.removeSessionStorageItem(
            SESSION_STORAGE_GRID_URL_KEY,
        );
    }

    /**
     * Get URL of previous grid from sessionStorage
     * If cache have been emptied before clicking on the button we reload the page
     */
    public getUrlPreviousGrid(): string {
        const gridUrl: string | undefined =
            this.storageService.getSessionStorageItem(
                SESSION_STORAGE_GRID_URL_KEY,
            );
        return (
            gridUrl ??
            this.location.prepareExternalUrl(this.location.path(true))
        );
    }

    public hasGridUrlKey(): boolean {
        let isValid: boolean = false;
        const gridUrl: string | undefined =
            this.storageService.getSessionStorageItem(
                SESSION_STORAGE_GRID_URL_KEY,
            );
        if (gridUrl) {
            const localeRegExp = new RegExp(`^${this.locale.urlPrefix}`);
            const isSameLocale = localeRegExp.test(gridUrl);
            if (!isSameLocale) {
                this.storageService.removeSessionStorageItem(
                    SESSION_STORAGE_GRID_URL_KEY,
                );
            }
            isValid = isSameLocale;
        }
        return isValid;
    }
}
